<template>
  <div id="rightTop">
    <div class="bg-color-black">  
      <div>
        <rightTopChart></rightTopChart>
      </div>
    </div>
  </div>
</template>
  
<script>
import rightTopChart from '@/components/wather/right/top'
export default {
  components: {
    rightTopChart
  }
}
</script>
  
<style lang="scss" scoped>
$box-height: 450px;
$box-width: 100%;

#rightTop {
  padding: 20px 16px;
  height: $box-height;
  width: $box-width;
  border-radius: 5px;

  .bg-color-black {
    height: $box-height - 35px;
    border-radius: 10px;
  }

  .text {
    color: #c3cbde;
  }

  .chart-box {
    margin-top: 16px;
    width: 170px;
    height: 170px;

    .active-ring-name {
      padding-top: 10px;
    }
  }
}
</style>
  